// @flow
import React from 'react';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

import { LABEL_COLORS_AVAILABLE, POSITIONS, SIZES } from './StastsItem.constants';
import { useStyles } from './styles';

export interface StatsItemProps {
  loading?: boolean;
  onClick?: () => void;
  size?: 'large' | 'medium' | 'small';
  subtitle?: string;
  title?: string;
  value: string | number;
  valueColor?: 'black' | 'green' | 'yellow' | 'red' | 'blue' | 'purple';
  valuePosition?: 'top' | 'bottom';
}

export const StatsItem = ({
  loading,
  onClick,
  size = SIZES.large,
  subtitle,
  title,
  value,
  valueColor = LABEL_COLORS_AVAILABLE.black,
  valuePosition = POSITIONS.bottom
}: StatsItemProps) => {
  const classes = useStyles({
    size,
    valueColor,
    valuePosition,
    isClickEnabled: !!onClick && value !== 0
  });

  const valueLabel = (
    <div className="valueLabel">
      <Typography
        className={classes.valueLabel}
        component="span"
        onClick={onClick && value !== 0 && onClick}
      >
        {value}
      </Typography>
    </div>
  );

  return loading ? (
    <Skeleton animation="wave" variant="text" height={50} />
  ) : (
    <div>
      {valuePosition === POSITIONS.top && !!title && valueLabel}
      <Typography className={classes.titleLabel}>{title}</Typography>
      {valuePosition === POSITIONS.bottom && !!title && valueLabel}
      {subtitle && <Typography className={classes.subtitleLabel}>{subtitle}</Typography>}
    </div>
  );
};
